import { render, staticRenderFns } from "./quick-help.vue?vue&type=template&id=a826ca18&"
import script from "./quick-help.vue?vue&type=script&lang=js&"
export * from "./quick-help.vue?vue&type=script&lang=js&"
import style0 from "./quick-help.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports